import { Select } from "antd";
import React from "react";

const SelectControl = ({ value, onChange, options, placeholder, status, mode }) => {
  return (
    <Select
      mode={mode}
      status={status}
      showSearch
      getPopupContainer={(triggerNode) => triggerNode.parentElement}
      value={value || null}
      className="w-full"
      placeholder={placeholder}
      optionFilterProp="children"
      onChange={onChange}
    >
      {options?.map((item, index) => (
        <Select.Option key={index} value={item}>
          {item === "" ? "NULL" : item}
        </Select.Option>
      ))}
    </Select>
  );
};

export default SelectControl;
